/**
 * containerStyle: Modal grid's containerStyle    object
 * onClose: Modal grid's colse event    functions(필수)
 * name: Modal grid's name    string
 * execLogic: Modal grid's exec logic event    function
 *
 */

import React from "react";
/** Components Import */
import Section from "./Section";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IndexedDb from "../Services/IndexedDb/IndexedDb";
import BasicButton from "./Button_Basic";
/** Icons Import */
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { disable } from "workbox-navigation-preload";

function File_Modal({
  containerStyle,
  onClose,
  name,
  children,
  buttonName1,
  buttonName2,
  buttonName3,
  deleteButton,
  execLogic,
  downLogic,
  deleteLogic,
  cancleLogic,
  checkLogic,
  hidden,
  buttonName4,
  buttonName5,
  disable,
  titleNmae,
  footer,
  button1Background,
  button2Background,
}) {
  const [lanData, setLanData] = React.useState([]);
  React.useEffect(() => {
    Init();
  }, []);
  const Init = async () => {
    let getLanData = [];

    await IndexedDb.GetAllDb("LanguageList").then((result) => {
      if (result.length > 0) {
        getLanData = result.filter((f) => f.lanType !== "MENU");
      }
    });

    setLanData(getLanData);
  };

  const CloseModal = () => {
    onClose();
  };

  const ExecLogic = () => {
    execLogic();
    CloseModal();
  };
  const DownLogic = () => {
    downLogic();
    CloseModal();
  };
  const DeleteLogic = () => {
    deleteLogic();
    CloseModal();
  };
  const Cancle = () => {
    cancleLogic();
    CloseModal();
  };
  const Check = () => {
    checkLogic();
  };

  return (
    <div className="modal-wrap">
      <div className="modal-container" style={containerStyle}>
        <div className={titleNmae ? "modal-title-sub " : "modal-title"}>
          <h3>{name}</h3>
          <button type="button" onClick={CloseModal}>
            <FontAwesomeIcon className="modal-icon" icon={faClose} />
          </button>
        </div>
        <Section />
        <div className="modal-content">{children}</div>
        <Section />
        <div className={footer ? "modal-footer-sub" : "modal-footer"}>
          <BasicButton
            style={{ width: "100px", backgroundColor: { button1Background } }}
            name={buttonName5}
            disabled={disable}
            onClick={DownLogic}
          />
          <BasicButton
            style={{ width: "100px", backgroundColor: { button1Background } }}
            name={buttonName1}
            disabled={disable}
            onClick={ExecLogic}
          />
          <BasicButton
            style={{ width: "100px", backgroundColor: { button1Background } }}
            name={deleteButton}
            disabled={disable}
            onClick={DeleteLogic}
          />
          {buttonName2 ? (
            <BasicButton
              style={{ width: "100px" }}
              name={buttonName2}
              onClick={Cancle}
            />
          ) : (
            ""
          )}{" "}
          {buttonName4 ? (
            <BasicButton
              style={{ width: "100px" }}
              name={buttonName4}
              onClick={Check}
            />
          ) : (
            ""
          )}
          <BasicButton
            style={{ width: "100px", backgroundColor: button2Background }}
            name={
              lanData.length > 0
                ? lanData.filter(
                    (f) => f.lanId === "Btn_Close" && f.lanType === "BTN"
                  )[0].lanName
                : ""
            }
            onClick={CloseModal}
            hidden={hidden}
          />
        </div>
      </div>
    </div>
  );
}

File_Modal.defaultProps = {
  buttonName3: "닫기",
};

export default File_Modal;
